import * as React from "react";
const SvgDropdownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 5, viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L5 5L10 0H0Z", fill: "#C6CDD2" }));
export default SvgDropdownArrow;
